import { call, put, takeEvery } from "redux-saga/effects";

import {
  ADD_INTERVIEWER_M,
  ADD_SHORTLIST_MANAGER_M,
  GET_INTERVIEWERS_LIST,
  GET_SHORTLIST_MANAGERS_DATA_LIST,
  UPDATE_INTERVIEWER_M,
  UPDATE_SHORTLIST_MANAGER,
} from "./actionTypes";

import {
  getInterviewersListFailed,
  getInterviewersListSuccess,
  getShortListManagersListFailed,
  getShortListManagersListSuccess,
} from "./actions";

//restapi end point
import * as constClass from "../../../../common/constant/constantURL";
import { put2 } from "../../../../helpers/api_helper";
import { getCall, postCall } from "../../../../helpers/fakebackend_helper";
import { verifyData } from "../../../../pages/Common/CommonFunctions/commonFunctions";
import {
  showErrorMessage,
  showLoader,
  showSuccessMessage,
} from "../../LoaderAndMessageStore/actions";

function* getShortlistManagersListHandler(dat) {
  try {
    let data = dat.payload;
    var url =
      constClass.REST_API_SHORTLIST_MANAGERS +
      `?page=${data.pageNumber}&pageSize=${data.pageSize}` +
      (verifyData(data.searchKeyword) ? `&keyword=${data.searchKeyword}` : "");
    var responsJSON = yield call(getCall, url);
    yield put(getShortListManagersListSuccess(responsJSON));
  } catch (error) {
    yield put(getShortListManagersListFailed(error));
  }
}

function* getInterviewersListHandler(dat) {
  try {
    let data = dat.payload;
    if (verifyData(data.pageNumber) && verifyData(data.pageSize)) {
      var url =
        constClass.REST_API_INTERVIEWERS +
        `?page=${data.pageNumber}&pageSize=${data.pageSize}` +
        (verifyData(data.searchKeyword)
          ? `&keyword=${data.searchKeyword}`
          : "");
      var responsJSON = yield call(getCall, url);
      yield put(getInterviewersListSuccess(responsJSON));
    }
  } catch (error) {
    yield put(getInterviewersListFailed(error));
  }
}

function* addShortlistHandler(dat) {
  try {
    yield put(showLoader());
    let data = dat.payload;
    var url = constClass.REST_API_SHORTLIST_MANAGERS;
    yield call(postCall, url, data);
    yield put(
      showSuccessMessage("Shortlist Manager has been added successfully."),
    );
  } catch (error) {
    yield put(showErrorMessage(error));
  }
}

function* updateShortlistHandler(dat) {
  try {
    yield put(showLoader());
    let data = dat.payload;
    var url = constClass.REST_API_SHORTLIST_MANAGERS;
    yield call(put2, url, data);
    yield put(
      showSuccessMessage("Shortlist Manager has been updated successfully."),
    );
  } catch (error) {
    yield put(showErrorMessage(error));
  }
}

function* addInterviewerHandler(dat) {
  try {
    yield put(showLoader());
    let data = dat.payload;
    var url = constClass.REST_API_INTERVIEWERS;
    yield call(postCall, url, data);
    yield put(showSuccessMessage("Interviewer has been added successfully."));
  } catch (error) {
    yield put(showErrorMessage(error));
  }
}

function* updateInterviewerHandler(dat) {
  try {
    yield put(showLoader());
    let data = dat.payload;
    var url = constClass.REST_API_INTERVIEWERS;
    yield call(put2, url, data);
    yield put(showSuccessMessage("Interviewer has been updated successfully."));
  } catch (error) {
    yield put(showErrorMessage(error));
  }
}

function* managersSaga() {
  yield takeEvery(
    GET_SHORTLIST_MANAGERS_DATA_LIST,
    getShortlistManagersListHandler,
  );
  yield takeEvery(GET_INTERVIEWERS_LIST, getInterviewersListHandler);
  yield takeEvery(ADD_SHORTLIST_MANAGER_M, addShortlistHandler);
  yield takeEvery(UPDATE_SHORTLIST_MANAGER, updateShortlistHandler);
  yield takeEvery(ADD_INTERVIEWER_M, addInterviewerHandler);
  yield takeEvery(UPDATE_INTERVIEWER_M, updateInterviewerHandler);
}

export default managersSaga;
